// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"countrysearch_inputBox__vtNF7"};